"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UpdateModel", {
    enumerable: true,
    get: function() {
        return UpdateModel;
    }
});
const _zod = require("zod");
const UpdateModel = _zod.z.object({
    __expectedVersion: _zod.z.number({
        description: 'The expected version of the entity.'
    }).int()
});

//# sourceMappingURL=update-model.js.map